import * as ActionType from '../../constants/constant_action_types';

const INITIAL_STATE = {
  list: [],
  pagination: {
    page: 1,
    perPage: 10,
    totalRows: 0,
  }
};

export default function entityInventoryReturnReducer( state = INITIAL_STATE, action ) {
  switch (action.type) {
    case ActionType.SET_ENTITY_INVENTORY_RETURN_LIST: {
      return {
        ...state,
        list: action.list
      }
    }

    case ActionType.SET_ENTITY_INVENTORY_RETURN_PAGINATION: {
      let newState = { ...state };
      if ( action.page ) newState.pagination.page = action.page;
      if ( action.perPage ) newState.pagination.perPage = action.perPage;
      if ( action.totalRows ) newState.pagination.totalRows = action.totalRows;
      return newState;
    }
    
    default:
      return state;
  }
}